module.exports = __webpack_public_path__ + "static/img/cdg.cab6d67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/cdg.png
// module id = PhY9
// module chunks = 1